import { useEffect, useState } from "react";
import { Loader2, Radio, Square, Sunrise } from "lucide-react";
import { api } from "@/lib/api";
import { recall, remember } from "@/lib/newsCache";

// One warm card in the morning: what happened while you slept.
export const OvernightCard = ({ speaker, lang }) => {
  const said = lang || "en";
  const [card, setCard] = useState(() => recall(`overnight:${said}`));

  useEffect(() => {
    const kept = recall(`overnight:${said}`);
    if (kept) return setCard(kept);
    api
      .get("/news/overnight", { params: { lang: said } })
      .then(({ data }) => {
        if (!data.text) return;
        setCard(data);
        remember(`overnight:${said}`, data);
      })
      .catch(() => {});
  }, [said]);

  if (!card?.text) return null;
  const reading = speaker.playing === "overnight";

  return (
    <div className="rounded-3xl border border-brand/30 bg-brand/5 p-5" data-testid="overnight-card">
      <div className="flex flex-wrap items-center gap-2">
        <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-brand">
          <Sunrise className="h-4 w-4" /> While you slept
        </p>
        <button
          data-testid="overnight-listen"
          onClick={() => speaker.play("overnight", async () => card.text)}
          className="ms-auto inline-flex min-h-[30px] items-center gap-1.5 rounded-full border border-white/10 px-3 text-xs text-ink-soft transition-colors hover:border-brand/50 hover:text-brand"
        >
          {speaker.loading === "overnight" ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
            : reading ? <Square className="h-3.5 w-3.5 text-brand" />
            : <Radio className="h-3.5 w-3.5 text-brand" />}
          {reading ? "Stop" : "Read it to me"}
        </button>
      </div>

      <p className="mt-3 text-sm leading-relaxed" dir="auto" data-testid="overnight-text">
        {card.text}
      </p>

      {card.stories?.length > 0 && (
        <ul className="mt-3 space-y-1.5">
          {card.stories.map((story) => (
            <li key={story.story_id} className="text-xs">
              <a href={story.url} target="_blank" rel="noreferrer" dir="auto"
                 data-testid={`overnight-story-${story.story_id}`}
                 className="hover:text-brand">
                {story.title}
              </a>
              <span className="text-ink-soft">
                {story.source ? ` · ${story.source}` : ""}
                {story.read_min ? ` · ${story.read_min} min` : ""}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
